import React from 'react';

import Treemap from '../../../components/charts/echarts/Treemap';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

function Interest({ domainEntries }) {
  //! TEMPORARY SOLUTION
  let tempDomainEntries = domainEntries;

  if (domainEntries.length && !domainEntries[0][SONAR_DATA_KEYS.INTEREST]) {
    tempDomainEntries = [];
  }

  return <Treemap data={tempDomainEntries} dataKey={SONAR_DATA_KEYS.INTEREST} />;
}

export default Interest;
